module.exports = __webpack_public_path__ + "images/emoji/checkered_flag.75cb7bc740f5990a5e21.png";